export default "__VITE_ASSET__$YtG210z__"